import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import BarTabsView from './BarTabs.view';

import * as fromApp from '../../../store/app';

import { OrderType } from 'app/enums/order-types';

import { ITab } from './BarTabs.model';
import { IReservationBar } from 'app/models/specs/reservationBar';

interface PropsFromState {
  reservationBar: IReservationBar | null;
}

interface Props extends PropsFromState {
  orderType: OrderType|null;
  onSelectedBarTab: (tab: OrderType) => void;
}

const BarTabs: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  const tabs: ITab[] | null = useMemo(() => {
    const tabs: ITab[] = [
      {
        value: OrderType.Delivery,
        label: t('reservationBar.tabs.delivery'),
        icon: 'cisMotorbike',
      },
      {
        value: OrderType.Shuttle,
        label: t('reservationBar.tabs.shuttle'),
        icon: 'cilCarAlt',
      },
      {
        value: OrderType.Taxi,
        label: t('reservationBar.tabs.taxi'),
        icon: 'cisTaxi',
      },
      {
        value: OrderType.Airport,
        label: t('reservationBar.tabs.airport'),
        icon: 'cisAirplaneMode',
      },
    ];
    const filteredTabs = tabs.filter((tab: ITab) => props.reservationBar?.tabs.includes(tab.value));
    if (filteredTabs.length > 1) {
      return filteredTabs;
    }

    return null;
  }, [props.reservationBar?.tabs]);

  return (
    <BarTabsView orderType={props.orderType} tabs={tabs} onSelectedTab={props.onSelectedBarTab}>
      {props.children}
    </BarTabsView>
  );
};

BarTabs.displayName = 'BarTabs';
BarTabs.defaultProps = {};

const mapStateToProps = (state: fromApp.AppState): PropsFromState => {
  return {
    reservationBar: state.settings.specs?.reservationBar || null,
  };
};

export default connect(mapStateToProps)(BarTabs);
